import * as React from 'react';
import SUIGaugeFiller from '@splunk/react-icons/enterprise/GaugeFiller';

const FillerGauge = (
    // eslint-disable-next-line no-undef
    props: Omit<React.ComponentProps<typeof SUIGaugeFiller>, 'screenReaderText'>
): React.ReactElement<SVGElement> => <SUIGaugeFiller {...props} screenReaderText={null} />;

export default FillerGauge;
